import { IRequirementRowPadding } from 'app/models/Placement/PlacementSummary';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useRequirementFilter } from '../../../Helpers/requirementFilter';
import {
  selectBookingInfo,
  selectEditableFields,
} from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { ConfirmationCheckbox } from '../../TableComponents/Confirmations/ConfirmationCheckbox';
import { ConfirmationsRow } from '../../TableComponents/Confirmations/ConfirmationsTable';

export const GtgComplete = ({ hasRequirements }: IRequirementRowPadding) => {
  const { t } = useTranslation();
  const { gtgComplete: initialValue } = useSelector(selectEditableFields);
  const {
    credentialing: { gtgComplete },
    requirementFilter,
  } = useSelector(selectBookingInfo);
  const { control, formState: { errors } } = useFormContext();

  const { display } = useRequirementFilter('booking-credentialing', requirementFilter, gtgComplete?.type);

  return display ? (
    <Controller
      control={control}
      name="gtgComplete"
      render={({ field: {onChange, value, ...rest }}) => (
        <ConfirmationsRow
          id="placement-booking-credentialing-good-to-go-complete"
          lastUpdatedBy={value?.lastUpdatedBy}
          lastUpdatedDate={value?.lastUpdatedAt}
          requirement={gtgComplete?.type}
          hasOtherRequirements={hasRequirements}
          controlComponent={
            <ConfirmationCheckbox
              label={t('placement.profile.summary.booking.credentialing.goodToGoComplete')}
              defaultState={initialValue}
              disabled
              onChange={onChange}
              value={value}
              {...rest}
            />
          }
        />
      )}
    />
  ) : null;
};
